import Footer from "./Footer";
import {Image} from "react-bootstrap";
import './StudentsGallery.css';

let JobShadowingGallery2024 = () => {
    const verticalImageList = [
        "img002.jpg",
        "img023.jpg",
        "img040.jpg",
        "img041.jpg",
        "img047.jpg",
        "img048.jpg",
        "img049.jpg",
        "img050.jpg",
        "img051.jpg",
    ]

    const horizontalImageList = [
         "img001.jpg",
         "img004.jpg",
         "img009.jpg",
         "img010.jpg",
         "img011.jpg",
         "img012.jpg",
         "img013.jpg",
         "img014.jpg",
         "img016.jpg",
         "img017.jpg",
         "img019.jpg",
         "img020.jpg",
         "img021.jpg",
         "img022.jpg",
         "img024.jpg",
         "img025.jpg",
         "img026.jpg",
         "img027.jpg",
         "img028.jpg",
         "img029.jpg",
         "img030.jpg",
         "img031.jpg",
         "img032.jpg",
         "img033.jpg",
         "img034.jpg",
         "img035.jpg",
         "img037.jpg",
         "img038.jpg",
         "img039.jpg",
         "img042.jpg",
         "img043.jpg",
         "img044.jpg",
         "img045.jpg",
         "img046.jpg",
         "img052.jpg"

    ]

    return(
        <div className="content text-center">
            <div>
                {verticalImageList.map(path => <Image className="imageVertical m-3" src={require("./img/galeria-jobshadowing/" + path)} rounded />)}
            </div>
            <div>
                {horizontalImageList.map(path => <Image className="imageHorizontal m-3" src={require("./img/galeria-jobshadowing/" + path)} rounded />)}
            </div>

        </div>
    )
}

export default JobShadowingGallery2024;